export const staticStylesForIpmReport = {
  cmlCircleSizeRelativeToImage: 0.04,
  noContent: {
    textAlign: 'center',
    color: '#08107B',
    height: '10mm',
  },
  stripedTableRow: {
    backgroundColor: 'rgba(0, 0, 0, 0.05)',
  },
  visualEventMarkerBtn: {
    position: 'absolute',
    display: 'block',
    width: '3rem',
    height: '3rem',
    lineHeight: '3rem',
    background: 'transparent',
    border: 'none',
    borderRadius: '50%',
  },
  visualEventMarkerIcon: {
    display: 'block',
    width: '3rem',
    height: '3rem',
    lineHeight: '3rem',
    background: 'transparent',
    fontSize: '3rem',
    color: 'orange',
  },
  mobileVisualEventMarkerBtn: {
    position: 'absolute',
    display: 'block',
    width: '2rem',
    height: '2rem',
    lineHeight: '2rem',
    background: 'transparent',
    border: 'none',
    borderRadius: '50%',
  },
  mobileVisualEventMarkerIcon: {
    display: 'block',
    width: '2rem',
    height: '2rem',
    lineHeight: '2rem',
    background: 'transparent',
    fontSize: '2rem',
    color: 'orange',
  },
  cmls: {
    position: 'absolute',
    top: '0',
    bottom: '0',
    height: '100%',
    width: '100%',
    margin: '0',
    padding: '0',
    'list-style': 'none',
  },
  cml: {
    display: 'flex',
    'justify-content': 'center',
    'align-items': 'center',
    'border-radius': '50%',
    '-webkit-border-radius': '50%',
    '-moz-border-radius': '50%',
    position: 'absolute',
    border: '1px solid $sky',
    'background-color': 'rgba(6, 155, 227, 0.2)',
    'container-type': 'size',
  },
  cmlLabel: {
    'font-size': '50cqh',
    'font-weight': 'bold',
    margin: '0rem',
  },
  vePhoto: {
    'max-height': '68mm',
    'max-width': '100%',
    padding: '1mm',
    'object-fit': 'contain',
  },
  veListTable: {
    tableLayout: 'fixed',
    borderCollapse: 'collapse',
  },
  uprightText: {
    writingMode: 'vertical-lr',
    textOrientation: 'mixed',
    margin: 'auto',
  },
  contentFit: {
    width: '100%',
    height: '100%',
  },
  textStyles: `.ipm-report__pre-field {
    line-height: normal;
    margin: 0px;
    white-space: pre-wrap;
    word-wrap: break-word;
    width: 100%;
  }`,
  tableStyles: `.ipm-report__page-frame table {
      max-width: 100%;
      border-collapse: collapse;
    }
    .ipm-report__page-frame table td {word-break: break-word;}
    .ipm-report__page-frame table th {word-wrap:break-word;}
    .ipm-report__page-frame table {font: inherit;}
    * {box-sizing: border-box; line-height: 1.25;}`,
  commonRadioStyleForPDF: `input[type="radio"]:before {
    position: relative;
    display: block;
    width: 14px;
    height: 14px;
    border: 1px solid #808080;
    border-radius: 50%;
    content: "";
    background: #FFF;
  }
  input[type="radio"]:after {
    position: relative;
    display: block;
    left: 1px;
    top: -15px;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    content: "";
  }
  input[type="radio"]:checked:after {
    background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAkklEQVQoU42QMQ4DIQwEF1xckTyDmjfwdN5AzTMuRQqfI/twZCFFChWSx7veTQBQSjnmnG/9+6u1PsYYr9bas/d+pn8gAClFFQBClMF8gYjAzDrPAK4I7pBrGPMFibIEpWikzG29Dj+X3XaNWUvydEQkzLxD5qrJTdEr0M2NNMjqCZClW6AKiM/U1cPY4BekxX8A2OxcboiS8FoAAAAASUVORK5CYII=');
    background-repeat:no-repeat;
    background-size: 10px;
    background-position: center;
    background-color: lightblue;
  }
  input[type="radio"]:disabled:after {
    filter: opacity(0.5);
    -webkit-filter: opacity(0.5);
  }
  input[type="radio"]:disabled:before {
    filter: opacity(0.5);
    -webkit-filter: opacity(0.5);
  }
  input[type="radio"]:not(:disabled):checked:hover:after {
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAkklEQVQoU42QMQ4DIQwEF1xckTyDmjfwdN5AzTMuRQqfI/twZCFFChWSx7veTQBQSjnmnG/9+6u1PsYYr9bas/d+pn8gAClFFQBClMF8gYjAzDrPAK4I7pBrGPMFibIEpWikzG29Dj+X3XaNWUvydEQkzLxD5qrJTdEr0M2NNMjqCZClW6AKiM/U1cPY4BekxX8A2OxcboiS8FoAAAAASUVORK5CYII=');
  }
  input[type="radio"]:not(:disabled):hover:before {
    border-color: #3D7591;
  }`,
  commonCheckBoxStyleForPdf: `
  input[type="checkbox"]:before {
    position: relative;
    display: block;
    width: 13px;
    height: 13px;
    border: 1px solid #808080;
    border-radius: 3px;
    content: "";
    background: #FFF;
  }
  input[type="checkbox"]:after {
    position: relative;
    display: block;
    left: 0px;
    top: -14px;
    width: 14px;
    height: 14px;
    content: "";
  }
  input[type="checkbox"]:checked:after {
    background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAHCAQAAABuW59YAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAAB2SURBVHjaAGkAlv8A3QDyAP0A/QD+Dam3W+kCAAD8APYAAgTVZaZCGwwA5wr0AvcA+Dh+7UX/x24AqK3Wg/8nt6w4/5q71wAAVP9g/7rTXf9n/+9N+AAAtpJa/zf/S//DhP8H/wAA4gzWj2P4lsf0JP0A/wADAHB0Ngka6UmKAAAAAElFTkSuQmCC');
    background-repeat:no-repeat;
    background-size: 10px;
    background-position: center;
    background-color: lightblue;
  }
  input[type="checkbox"]:disabled:after {
    filter: opacity(0.5);
    -webkit-filter: opacity(0.5);
  }
  input[type="checkbox"]:disabled:before {
    filter: opacity(0.5);
    -webkit-filter: opacity(0.5);
  }
  input[type="checkbox"]:not(:disabled):checked:hover:after {
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAHCAQAAABuW59YAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAAB2SURBVHjaAGkAlv8A3QDyAP0A/QD+Dam3W+kCAAD8APYAAgTVZaZCGwwA5wr0AvcA+Dh+7UX/x24AqK3Wg/8nt6w4/5q71wAAVP9g/7rTXf9n/+9N+AAAtpJa/zf/S//DhP8H/wAA4gzWj2P4lsf0JP0A/wADAHB0Ngka6UmKAAAAAElFTkSuQmCC');
  }
  input[type="checkbox"]:not(:disabled):hover:before {
    border-color: #3D7591;
  }`,
};
